import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/g49633-dark.png")